module.exports = __webpack_public_path__ + "static/media/Double Matting No Writing.23361f60.png";